import { defineMessages } from 'react-intl';

import {
  ServiceGroupName,
  ServiceType,
} from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';

export const serviceNamesDefaultMessage = defineMessages<ServiceType>({
  [ServiceType.ServiceTypeInvalidValue]: {
    id: 'subscriptions.service.0',
    defaultMessage: 'Invalid Value',
  },
  // WA-6209: uploads are no longer metered, so the per-upload counters (1..6)
  // were removed from the protocol. Dental-photo upload survives as the enabler.
  [ServiceType.ServiceType_Enable_UploadDentalPhoto]: {
    id: 'subscriptions.service.5',
    defaultMessage: 'Dental Photo Uploads',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_GP_Analysis]: {
    id: 'subscriptions.service.100',
    defaultMessage:
      '{amount, plural, =0 {Radiology Report} one {{amount} Radiology Report} other {{amount} Radiology Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_Endodontic_Analysis]: {
    id: 'subscriptions.service.101',
    defaultMessage:
      '{amount, plural, =0 {Endo Report} one {{amount} Endo Report} other {{amount} Endo Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_Implantology_Analysis]: {
    id: 'subscriptions.service.102',
    defaultMessage:
      '{amount, plural, =0 {Implant Report} one {{amount} Implant Report} other {{amount} Implant Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_ThirdMolar_Analysis]: {
    id: 'subscriptions.service.103',
    defaultMessage:
      '{amount, plural, =0 {3rd Molar Report} one {{amount} 3rd Molar Report} other {{amount} 3rd Molar Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_STL_Analysis]: {
    id: 'subscriptions.service.104',
    defaultMessage:
      '{amount, plural, =0 {DICOM to STL conversion} one {{amount} DICOM to STL conversion} other {{amount} DICOM to STL conversions}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_Orthodontic_Analysis]: {
    id: 'subscriptions.service.105',
    defaultMessage:
      '{amount, plural, =0 {Ortho Report} one {{amount} Ortho Report} other {{amount} Ortho Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_CBCT_IOS_Superimposition_Analysis]: {
    id: 'subscriptions.service.106',
    defaultMessage:
      '{amount, plural, =0 {CBCT IOS Superimposition} other {{amount} CBCT IOS Superimposition}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_IOS_Segmentation_Analysis]: {
    id: 'subscriptions.service.107',
    defaultMessage:
      '{amount, plural, =0 {IOS Segmentation} one {{amount} IOS Segmentation} other {{amount} IOS Segmentations}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_IOXRay_GP_Analysis]: {
    id: 'subscriptions.service.108',
    defaultMessage:
      '{amount, plural, =0 {FMX AI Report} one {{amount} FMX AI Report} other {{amount} FMX AI Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_Panoramic_GP_Analysis]: {
    id: 'subscriptions.service.109',
    defaultMessage:
      '{amount, plural, =0 {Pano AI Report} one {{amount} Pano AI Report} other {{amount} Pano AI Reports}}',
  },
  // Both countable and enabler
  [ServiceType.ServiceType_Order_DentalPhoto_GP_Analysis]: {
    id: 'subscriptions.service.110',
    defaultMessage:
      '{amount, plural, =0 {Dental Photo Classification} one {{amount} Dental Photo Classification} other {{amount} Dental Photo Classification}}',
  },
  [ServiceType.ServiceType_Order_ImplantStudio_Analysis]: {
    id: 'subscriptions.service.111',
    defaultMessage: 'Implant AI',
  },
  [ServiceType.ServiceType_Order_OrthoStudio_Analysis]: {
    id: 'subscriptions.service.112',
    defaultMessage: 'Ortho AI',
  },
  [ServiceType.ServiceType_Order_Transcriptor]: {
    id: 'subscriptions.service.113',
    defaultMessage: 'Transcriptor',
  },
  // Only enabler
  [ServiceType.ServiceType_Enable_CollaborationTool]: {
    id: 'subscriptions.service.200',
    defaultMessage: 'Collaboration Tool',
  },
  // Only enabler
  [ServiceType.ServiceType_Enable_DesktopApp]: {
    id: 'subscriptions.service.202',
    defaultMessage: 'Diagnocat Imaging',
  },
  [ServiceType.ServiceType_Enable_3DModelsWithConditions]: {
    id: 'subscriptions.service.203',
    defaultMessage: '3D models with conditions',
  },
  [ServiceType.ServiceType_Enable_SuggestedTreatment]: {
    id: 'subscriptions.service.204',
    defaultMessage: 'Suggested treatment',
  },
  [ServiceType.ServiceType_Enable_Transcriptor]: {
    id: 'subscriptions.service.205',
    defaultMessage: 'Transcriptor',
  },
  [ServiceType.ServiceType_Expand_Storage]: {
    id: 'subscriptions.service.206',
    defaultMessage: 'Expand storage',
  },
});

export const serviceGroupNamesDefaultMessage = defineMessages<ServiceGroupName>(
  {
    [ServiceGroupName.ServiceGroupNameInvalidValue]: {
      id: 'subscriptions.serviceGroupNames.0',
      defaultMessage: 'Invalid value',
    },
    [ServiceGroupName.ServiceGroupNameEmpty]: {
      id: 'subscriptions.serviceGroupNames.1',
      defaultMessage: 'Empty group name',
    },
    [ServiceGroupName.ServiceGroupNameAnalysis3D]: {
      id: 'subscriptions.serviceGroupNames.3',
      defaultMessage: '3D AI Reports',
    },
    [ServiceGroupName.ServiceGroupNameAnalysis2D]: {
      id: 'subscriptions.serviceGroupNames.4',
      defaultMessage: '2D AI Reports',
    },
    [ServiceGroupName.ServiceGroupNameUpload3D]: {
      id: 'subscriptions.serviceGroupNames.5',
      defaultMessage: '3D uploads',
    },
    [ServiceGroupName.ServiceGroupNameUpload2D]: {
      id: 'subscriptions.serviceGroupNames.6',
      defaultMessage: '2D uploads',
    },
    [ServiceGroupName.ServiceGroupNameTrial]: {
      id: 'subscriptions.serviceGroupNames.7',
      defaultMessage: 'Trial credits',
    },
  },
);
